import { gql } from "@apollo/client";

export const GET_WELLNESSPLAN_BY_USER_AND_PET = gql` 
query getWellnessplanByUserAndPet($petId: String!){
  getWellnessplanByUserAndPet(petId: $petId){
        success
        messages
        wellnessPlanByPet {
            pet {
                id
                name
                image
                speciesName
                species
                breed
                breedName
                birthdate
                gender
                reasonForVisit
                age
                medicalRecordsSeenByVet
                isDesexed
                idColor
                colorName
                isWellnessplan
                socStatus
                lastAppointmentDate
            }
            pendingEzyvetInvoices {
                id
            }
            wellnessPlanDetails {
                status
                animal_id
                contact_id
                wellnessId
                wellnessPlanId
                startDate
                endDate
                isAutoRenewal
                renewalStatus
                nextRenewal
                nextBillingDate
                totalSavings
                cardId
                 cardDetails {
                    id
                    cardBrand
                    cardType
                    last4
                    expMonth
                    expYear
                    isDefault
                    hasSubscription
                    cardholderName
                    customerId
                    expiryStatus
                    isActive
                }
                location {
                    idLocation
                    locationName
                    address
                    city
                    state
                    status
                    email
                    phoneNumber
                    timeZone
                    totalDistance
                    background
                }
            }
            wellnessplanBenefitUsage {
                wellnessplanBenefitUsageId
                wellnessId
                active
                allocated
                used
                wellnessplanId
                wellnessplanBenefitId
                wellnessMembershipDetailsId
                wellnessMembershipDetailsCycle
                created_at
                modified_at
                class
                wellnessplanBenefitName
                mappedCategory
                class_id
                usedFor
                usedFor_id
                schemaName
                displayName
            }
            wellnessPlan {
                wellnessplanId
                wellnessplanName
                billingInterval
                numberOfBillingCycles
                active
                created_at
                modified_at
                price
                schemaName
                planType
            }
                pendingSquareInvoices {
            invoiceId
            invoiceNumber
            subscriptionId
            orderId
            publicUrl
            customerId
            email
            amount
            currency
            status
            dueDate
            description
            contactId
            animalId
            schemaName
            createdAt
            updatedAt
        }
            isSubscriptionActive
            wellnessPlanPaymentStatus
            subscriptionId
            planId
            planName
            planType
            isScratchpay
            isOverdue
        }
    }
}`;
